import { useIsProfileFieldsEnabled } from "@circle-react-shared/ProfileFields/useIsProfileFieldsEnabled";
import { useMemo } from "react";

import type { Form } from "@/react/types/Form";

const isProfileFieldElement = (element: Form["elements"][number]) =>
  element.type === "field" && Boolean(element.attributes.profile_field_id);

export const useFilteredFormForProfileFields = (form: Form): Form => {
  const isProfileFieldsEnabled = useIsProfileFieldsEnabled();

  return useMemo(
    () =>
      isProfileFieldsEnabled
        ? form
        : {
            ...form,
            elements: form.elements.filter(
              element => !isProfileFieldElement(element),
            ),
          },
    [form, isProfileFieldsEnabled],
  );
};
